import React from 'react';
import { View, StyleSheet, Platform, ViewStyle, StyleProp } from 'react-native';
import { Text } from '@/components/common/text';
import { useThemedStyles } from '@/hooks/shared/useThemeColors';
import type { ThemeContextValue } from '@/hooks/shared/useThemeColors';
import { ResioLogo } from '@/assets/ResioLogo';

type Props = {
  show?: boolean;
  style?: StyleProp<ViewStyle>;
};

export const AuthHeader: React.FC<Props> = ({ show = true, style }) => {
  // Hook must run before the early return (rules of hooks).
  const styles = useThemedStyles(makeStyles);

  if (!show) return null;
  return (
    <View style={[styles.header, style]}>
      <View style={styles.logoContainer}>
        <ResioLogo width={64} height={64} style={styles.logoIcon} />
        <Text style={styles.logoText}>RESIO</Text>
      </View>
    </View>
  );
};

const makeStyles = ({ colors, semantic }: ThemeContextValue) => StyleSheet.create({
  header: {
    flexDirection: 'row',
    alignItems: 'center',
    padding: 16,
    borderBottomWidth: 1,
    borderBottomColor: semantic.border.secondary,
    backgroundColor: 'transparent',
    ...Platform.select({
      web: { position: 'sticky' as any, top: 0, zIndex: 10 },
    }),
  },
  logoContainer: { flexDirection: 'row', alignItems: 'center' },
  logoIcon: { marginRight: 8, width: 64, height: 64 },
  logoText: {
    fontSize: Platform.select({ web: 48, default: 32 }) as number,
    fontWeight: '600',
    // Was the static SEMANTIC_COLORS.text.primary (#EEF1F4, near-white), which
    // rendered white-on-white in the light theme.
    color: colors.text.primary,
    letterSpacing: 0.5,
  },
});
